export default __webpack_public_path__ + "static/media/generativeText.1e08f911.jpeg";